import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import Trackers from '../analytics';
import setDataLayer from './setDataLayer';
import { TRACK_PAGE_VIEWED, TRACK_EVENT } from '../constants';
var trackerConfig = {};
export var executeListners = function executeListners() {
  var instance = trackerConfig.instance,
      callback = trackerConfig.callback,
      config = trackerConfig.config,
      debug = trackerConfig.debug;

  if (!config) {
    throw new ReferenceError('Tracker Config missing. Use setTrackerConfig() to set tracker config on application bootstrap');
  }

  instance.on('*', function (event) {
    var type = event.type,
        data = event.data,
        action = event.action;

    var _ref = data || {},
        eventDetails = _ref.eventDetails;

    if (callback) {
      callback(_objectSpread({}, config, data, {
        type: type,
        action: action,
        debug: debug
      }));
    }

    document.dispatchEvent(new CustomEvent('analytics', {
      detail: _objectSpread({
        type: type,
        action: action
      }, eventDetails)
    }));
  });
};
export var setTrackerConfig = function setTrackerConfig(_ref2) {
  var config = _ref2.config,
      eventActions = _ref2.eventActions,
      pageViewActions = _ref2.pageViewActions,
      callback = _ref2.callback,
      debug = _ref2.debug;
  trackerConfig.config = config;
  trackerConfig.pageViewActions = pageViewActions;
  trackerConfig.eventActions = eventActions;
  trackerConfig.callback = callback || setDataLayer;
  trackerConfig.debug = debug || false;
  executeListners();
};
export var getTracker = function getTracker() {
  if (!trackerConfig.instance) {
    trackerConfig.instance = new Trackers([TRACK_PAGE_VIEWED, TRACK_EVENT]);
  }

  return trackerConfig;
};